export default function (refs = "mainContainer") {
  return {
    mounted() {
      this.$bus.$on("setMainScroll", this.handleSetMainScroll);
      this.$refs[refs].addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
      this.$bus.$emit("mainScroll"); // 销毁的时候触发并设置dom为undefined，totop消失
      this.$bus.$off("setMainScroll", this.handleSetMainScroll);
      this.$refs[refs].removeEventListener("scroll", this.handleScroll);
    },
    methods: {
      handleScroll() {
        this.$bus.$emit("mainScroll", this.$refs[refs]);
      },
      handleSetMainScroll(scrollTop) {
        this.$refs[refs].scrollTop = scrollTop;
      },
    },
  };
}
